module.exports = __webpack_public_path__ + "img/VL_21_01.edb92a6d.png";